<div *ngIf="!isChatRedirect" class="container-fluid" style="min-height: 100%">
  <div class="row login-section">
    <div class="col-md-4 officeDiv mx-auto">
      <div>
        <div
          style="position: sticky; top: 0px; left: 0; right: 0; z-index: 1; padding-bottom: 0px; background-color: #fff"
        >
          <div class="company-logo-container">
            <div>
              <img *ngIf="companyLogo && !hideValuetestLogo" [src]="companyLogo" alt="Company Logo" />
            </div>
            <!-- <div [ngClass]="{ 'logo-wrapper': hideValuetestLogo }">
              <img src="../../assets/images/compcheck_logo.png" />
            </div> -->
          </div>
          <h3 class="mt-3 mb-0">
            {{ currentRoute !== 'signup' ? 'Create an account' : askUserType ? '' : 'Login' }}
          </h3>
          <div class="text-center mt-2 redirect-ac" *ngIf="!showResetForm && !afterContinueloanOfficerFlag">
            {{ currentRoute !== 'signup' || askUserType ? 'Already have an account' : "Don't have an account" }}
            ?
            <a class="aCls" (click)="switchFunc(currentRoute !== 'signup' ? 'Login' : 'signup')">{{
              currentRoute !== 'signup' || askUserType ? 'Login' : 'Signup'
            }}</a>
          </div>
        </div>
      </div>
      <!-- agent form -->
      <form [formGroup]="signupForm" *ngIf="currentRoute === 'agent'" (submit)="agentSignup()">
        <div>
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>First Name</mat-label>
            <input
              type="text"
              matInput
              formControlName="firstName"
              id="firstName"
              pattern="^[a-zA-Z]+$"
              aria-describedby="firstName"
              required
              placeholder="First Name*"
            />
            <mat-error
              *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.required"
              class="invalid-feedback"
            >
              First Name is required</mat-error
            >
            <mat-error
              *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.maxlength"
              class="invalid-feedback"
            >
              Maximum 25 characters are allowed</mat-error
            >
            <mat-error
              *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.pattern"
              class="invalid-feedback"
            >
              Only alphabets are allowed</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Last Name</mat-label>
            <input
              type="text"
              matInput
              formControlName="lastName"
              id="lastName"
              pattern="^[a-zA-Z]+$"
              aria-describedby="lastName"
              required
              placeholder="Last Name*"
            />
            <mat-error
              *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.required"
              class="invalid-feedback"
            >
              Last Name is required</mat-error
            >
            <mat-error
              *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.maxlength"
              class="invalid-feedback"
            >
              Maximum 25 characters are allowed</mat-error
            >
            <mat-error
              *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.pattern"
              class="invalid-feedback"
            >
              Only alphabets are allowed</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="email"
              formControlName="email"
              id="email"
              aria-describedby="email"
              required
              placeholder="Email*"
            />
            <mat-error
              *ngIf="signupControls.email.errors && signupControls.email.errors.required"
              class="invalid-feedback"
              >Email is required</mat-error
            >
            <mat-error
              *ngIf="signupControls.email.errors && signupControls.email.errors.pattern"
              class="invalid-feedback"
              >Email must be a valid</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
            <mat-error
              *ngIf="signupControls.phone.errors && signupControls.phone.errors.required"
              class="invalid-feedback"
              aria-label="phone No. is required"
            >
              Phone No. is required
            </mat-error>
            <mat-error
              *ngIf="signupControls.phone.errors && signupControls.phone.errors.pattern"
              class="invalid-feedback"
            >
              Phone number must be valid
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              formControlName="password"
              class="pass-fld"
              aria-describedby="password"
              placeholder="Password*"
              required
            />
            <mat-error
              *ngIf="signupControls.password.errors && signupControls.password.errors.required"
              class="invalid-feedback"
            >
              Password is required
            </mat-error>
            <mat-error
              *ngIf="signupControls.password.errors && signupControls.password.errors.minlength"
              class="invalid-feedback"
            >
              Password must be at least 6 characters</mat-error
            >
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              type="password"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Confirm Password*"
              (input)="onConfirmPasswordInput()"
              required
            />
            <mat-error
              *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.required"
              class="invalid-feedback"
            >
              Confirm Password is required
            </mat-error>
            <mat-error
              *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.minlength"
              class="invalid-feedback"
            >
              Confirm Password must be at least 6 characters</mat-error
            >
            <mat-error
              *ngIf="
                signupControls.confirmPassword.hasError('passwordMismatch') && signupControls.confirmPassword.dirty
              "
              class="invalid-feedback"
            >
              Passwords do not match.
            </mat-error>
          </mat-form-field>

          <h6 class="addressLabelCls">MLS Access Information <span> * </span></h6>
          <div formGroupName="mlsInfoForm">
            <mat-form-field appearance="outline" class="col-md-6">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" (selectionChange)="onStateSelection($event)">
                <mat-option value="" disabled> Select State </mat-option>
                <mat-option *ngFor="let state of stateList | keyvalue" [value]="state.key">
                  {{ state.value | titlecase }} - {{ state.key | uppercase }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  mlsInfoForm.get('state').errors &&
                  mlsInfoForm.get('state').errors.required &&
                  mlsInfoForm.get('state').dirty
                "
                class="invalid-feedback"
              >
                State is required
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" [ngClass]="{ 'select-progress': isLoadingStateMLS }" class="col-md-6">
              <mat-label>MLS Board</mat-label>
              <mat-select [disabled]="isLoadingStateMLS" formControlName="mlsBoard">
                <mat-option value="" disabled>Select MLS Board</mat-option>
                <mat-option *ngFor="let mls of stateMlsList" [value]="mls.MLSBoard">
                  {{ mls.MLSBoard }} - {{ mls.MLSName }}
                </mat-option>
                <mat-option value="" *ngIf="!isLoadingStateMLS && !stateMlsList.length">No MLSBoard</mat-option>
              </mat-select>
              <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingStateMLS"></mat-spinner>
            </mat-form-field>

            <div class="form-row" style="margin-left: 0.75rem !important">
              <div class="form-group col-md-9 mb-0" style="display: flex; align-items: center">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Membership Number</mat-label>
                  <input
                    matInput
                    type="text"
                    id="membershipNumber"
                    formControlName="memberId"
                    placeholder="Membership Number*"
                  />
                </mat-form-field>
              </div>
              <div class="form-group col-md-3" style="display: flex; align-items: center">
                <button
                  mat-flat-button
                  type="button"
                  class="btn btn-primary blueBtn add"
                  (click)="addMlsInfo()"
                  [disabled]="!mlsInfoForm.valid"
                >
                  + ADD
                </button>
              </div>
              <div>
                <span class="info-txt"
                  ><mat-icon class="info-icon">info</mat-icon>To help us validate your membership with the MLS, please
                  provide your MLS Membership Number.</span
                >
              </div>
            </div>
          </div>
          <div class="row" *ngIf="mlsInformation.data && mlsInformation.data.length > 0">
            <div class="col-md-12">
              <div class="table_base table-container mt-3 mb-5 mls-list">
                <div class="table-responsive table_wrap">
                  <mat-spinner *ngIf="isLoadingAgentMLS" class="loading-spinner"></mat-spinner>
                  <table
                    mat-table
                    [dataSource]="mlsInformation"
                    class="mat-elevation-z2 w-100"
                    *ngIf="mlsInformation.data && mlsInformation.data.length > 0"
                  >
                    <ng-container matColumnDef="state">
                      <th mat-header-cell *matHeaderCellDef>State</th>
                      <td mat-cell *matCellDef="let element">
                        {{ stateList[element.state] | titlecase }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="mlsBoard">
                      <th mat-header-cell *matHeaderCellDef>MLS</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.mlsBoard }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="memberId">
                      <th mat-header-cell *matHeaderCellDef>Membership ID</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.memberId }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>Status</th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        [ngClass]="element.status == 'invalid' ? 'incomplete' : 'success'"
                      >
                        {{ element.status == 'invalid' ? 'Pending' : 'Success' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef class="actionsWrap">Actions</th>
                      <td mat-cell *matCellDef="let element" class="actionsWrap">
                        <button type="button" mat-icon-button aria-label="delete" class="delete">
                          <i class="material-icons" style="font-size: 20px" (click)="deleteMLS(element)"> delete </i>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="mlsTableColumnList"></tr>
                    <tr mat-row *matRowDef="let row; columns: mlsTableColumnList"></tr>
                    <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingAgentMLS"></mat-spinner>
                  </table>
                </div>
              </div>

              <div
                class="py-2 text-left"
                style="padding-left: 15px"
                *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue == 'valuetest'"
              >
                We’re unable to verify the number you entered as an MLS Member ID. Please ensure you’re not entering
                your license number. <br />
                If verification still doesn’t work, you can proceed with account creation and then call us at
                <b>(702) 591-7245</b> to complete any pending verification. – PropMix
              </div>
              <div
                class="py-2 text-left"
                style="padding-left: 15px"
                *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue != 'valuetest'"
              >
                Your MLS membership details couldn’t be verified. Please check your Membership ID. If you’re still
                unable to verify, don’t worry — wPlease go ahead and submit the form.
              </div>
            </div>
          </div>
          <div class="flex_center w-100" *ngIf="!isLoadingAgentMLS && !mlsInformation.data">
            <div class="notFound text-center noData">
              <div>
                <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                <h4>No MLS memberships found</h4>
              </div>
            </div>
          </div>
          <div class="continue">
            <button
              mat-flat-button
              type="submit"
              class="btn btn-primary btn-block blueBtn mt-2"
              *ngIf="signupForm.valid && mlsInformation.data.length != 0 && !isUserAuthenticationProgress"
            >
              <!-- &&
            showCreateAccount -->
              <ng-container *ngIf="!isUserAuthenticationProgress"> Create Account </ng-container>
              <span *ngIf="isUserAuthenticationProgress"
                >&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Creating...</span
              >
            </button>
          </div>
        </div>
      </form>

      <!-- signin form -->
      <form
        [formGroup]="officeForm"
        (ngSubmit)="officeFormSubmit()"
        *ngIf="currentRoute === 'signup' && !showResetForm && !askUserType"
      >
        <div
          class="alert"
          [ngClass]="{ 'alert-danger': alerts.type == 'error', 'text-info pl-0': alerts.type == 'info' }"
          *ngIf="alerts && alerts.type != ''"
        >
          {{ alerts.message }}
        </div>
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
          <mat-error
            *ngIf="officeFormControls.email.errors && officeFormControls.email.errors.required"
            class="invalid-feedback"
            >Email is required</mat-error
          >
          <mat-error
            *ngIf="officeFormControls.email.errors && officeFormControls.email.errors.pattern"
            class="invalid-feedback"
            >Email must be a valid</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            class="pass-fld"
            aria-describedby="password"
            placeholder="Password*"
            required
          />
          <mat-error
            *ngIf="officeFormControls.password.errors && officeFormControls.password.errors.required"
            class="invalid-feedback"
          >
            Password is required
          </mat-error>
          <mat-error
            *ngIf="officeFormControls.password.errors && officeFormControls.password.errors.minlength"
            class="invalid-feedback"
          >
            Password must be at least 6 characters</mat-error
          >
        </mat-form-field>
        <a class="float-right mb-3 pr-3 forgot-Pass" (click)="goToReset()"> <b> Forgot Password ?</b></a>
        <div class="continue">
          <button class="btn btn-info btn-block blueBtn" [disabled]="!officeForm.valid || isUserAuthenticationProgress">
            <ng-container *ngIf="!isUserAuthenticationProgress"> Login </ng-container>
            <span *ngIf="isUserAuthenticationProgress"
              >&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Logging In...</span
            >
          </button>
        </div>
      </form>

      <!-- RESET FORM -->
      <form *ngIf="showResetForm" [formGroup]="resetForm" (ngSubmit)="resetFormSubmit()">
        <div
          class="alert mb-0"
          [ngClass]="{
            'alert-success': alerts.type == 'success',
            'alert-danger': alerts.type == 'danger',
            'text-info pl-0': alerts.type == 'info'
          }"
          *ngIf="alerts && alerts.type != ''"
        >
          <b>{{ alerts.message }}</b>
        </div>
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
          <mat-error
            *ngIf="resetFormControls.email.errors && resetFormControls.email.errors.required"
            class="invalid-feedback"
            >Email is required</mat-error
          >
          <mat-error
            *ngIf="resetFormControls.email.errors && resetFormControls.email.errors.pattern"
            class="invalid-feedback"
            >Email must be a valid</mat-error
          >
        </mat-form-field>

        <div class="continue">
          <button class="btn btn-info btn-block blueBtn" [disabled]="!resetForm.valid">Reset Password</button>
        </div>
        <div class="text-center mt-3 redirect-ac">
          Remember your password?
          <a class="aCls" (click)="goToLogin()"> Log in</a>
        </div>
      </form>

      <!-- loan officer form -->
      <form
        [formGroup]="loanOfficer"
        (ngSubmit)="loanOfficeFormSubmit()"
        *ngIf="currentRoute === 'loan-officer' && !afterContinueloanOfficerFlag"
      >
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>First Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="firstName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="firstName"
            required
            placeholder="First Name*"
          />
          <mat-error
            *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.required"
            class="invalid-feedback"
          >
            First Name is required</mat-error
          >
          <mat-error
            *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Last Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="lastName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="lastName"
            required
            placeholder="Last Name*"
          />
          <mat-error
            *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.required"
            class="invalid-feedback"
          >
            Last Name is required</mat-error
          >
          <mat-error
            *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
          <mat-error
            *ngIf="loanOfficerControls.email.errors && loanOfficerControls.email.errors.required"
            class="invalid-feedback"
            >Email is required</mat-error
          >
          <mat-error
            *ngIf="loanOfficerControls.email.errors && loanOfficerControls.email.errors.pattern"
            class="invalid-feedback"
            >Email must be a valid</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
          <mat-error
            *ngIf="loanOfficerControls.phone.errors && loanOfficerControls.phone.errors.required"
            class="invalid-feedback"
            aria-label="phone No. is required"
          >
            Phone No. is required
          </mat-error>
          <mat-error
            *ngIf="loanOfficerControls.phone.errors && loanOfficerControls.phone.errors.pattern"
            class="invalid-feedback"
          >
            Phone number must be valid
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            id="password"
            class="pass-fld"
            aria-describedby="password"
            placeholder="Password*"
            required
          />
          <mat-error
            *ngIf="loanOfficerControls.password.errors && loanOfficerControls.password.errors.required"
            class="invalid-feedback"
          >
            Password is required
          </mat-error>
          <mat-error
            *ngIf="loanOfficerControls.password.errors && loanOfficerControls.password.errors.minlength"
            class="invalid-feedback"
          >
            Password must be at least 6 characters</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            type="password"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirm Password*"
            (input)="onConfirmPasswordInput()"
            required
          />
          <mat-error
            *ngIf="loanOfficerControls.confirmPassword.errors && loanOfficerControls.confirmPassword.errors.required"
            class="invalid-feedback"
          >
            Confirm Password is required
          </mat-error>
          <mat-error
            *ngIf="loanOfficerControls.confirmPassword.errors && loanOfficerControls.confirmPassword.errors.minlength"
            class="invalid-feedback"
          >
            Confirm Password must be at least 6 characters</mat-error
          >
          <mat-error
            *ngIf="
              loanOfficerControls.confirmPassword.hasError('passwordMismatch') &&
              loanOfficerControls.confirmPassword.dirty
            "
            class="invalid-feedback"
          >
            Passwords do not match.
          </mat-error>
        </mat-form-field>

        <h6 class="addressLabelCls">Address (optional)</h6>
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Address</mat-label>
          <input matInput type="text" id="address" formControlName="streetAddress" placeholder="Street Address" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>City</mat-label>
          <input matInput type="text" id="city" formControlName="city" placeholder="City" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>State</mat-label>
          <mat-select formControlName="state" (selectionChange)="onStateSelection($event)">
            <mat-option value="" disabled> Select State </mat-option>
            <mat-option *ngFor="let state of stateList | keyvalue" [value]="state.key">
              {{ state.value | titlecase }} - {{ state.key | uppercase }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Zipcode</mat-label>
          <input matInput type="number" id="zip" formControlName="zipCode" placeholder="ZIP" />
        </mat-form-field>
        <div class="continue">
          <button
            type="submit"
            class="btn btn-info btn-block mt-2 blueBtn"
            [disabled]="!loanOfficer.valid || isLoading"
          >
            <ng-container *ngIf="!isLoading"> Sign Up </ng-container>
            <span *ngIf="isLoading">&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Redirecting...</span>
          </button>
          <div class="loanOfficer-verbage" *ngIf="displayLoanOfficerVerbage">
            <h5>WHAT YOU AND YOUR AGENTS GET!</h5>
            <p>Three AI/Appraisal tools. One research platform.</p>
            <ul>
              <li><strong>CompCheck.ai </strong> – Public Records Search</li>
              <li><strong>ValueTest.ai</strong> – MLS Search (with credentials)</li>
              <li><strong>Smart Research CMA</strong> – BETA</li>
            </ul>
            <div class="highlight">All FREE for unlimited use. Share with your agents!</div>
          </div>
        </div>
      </form>

      <!-- appraisar Signup Form  -->
      <form
        [formGroup]="appraisarForm"
        (ngSubmit)="appraisarFormSubmit()"
        *ngIf="currentRoute === 'appraisar' && !isAppraisarSuccess"
      >
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>First Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="firstName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="firstName"
            required
            placeholder="First Name*"
          />
          <mat-error
            *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.required"
            class="invalid-feedback"
          >
            First Name is required</mat-error
          >
          <mat-error
            *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Last Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="lastName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="lastName"
            required
            placeholder="Last Name*"
          />
          <mat-error
            *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.required"
            class="invalid-feedback"
          >
            Last Name is required</mat-error
          >
          <mat-error
            *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
          <mat-error
            *ngIf="appraisarControls.email.errors && appraisarControls.email.errors.required"
            class="invalid-feedback"
            >Email is required</mat-error
          >
          <mat-error
            *ngIf="appraisarControls.email.errors && appraisarControls.email.errors.pattern"
            class="invalid-feedback"
            >Email must be a valid</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
          <mat-error
            *ngIf="appraisarControls.phone.errors && appraisarControls.phone.errors.required"
            class="invalid-feedback"
            aria-label="phone No. is required"
          >
            Phone No. is required
          </mat-error>
          <mat-error
            *ngIf="appraisarControls.phone.errors && appraisarControls.phone.errors.pattern"
            class="invalid-feedback"
          >
            Phone number must be valid
          </mat-error>
        </mat-form-field>

        <div class="continue">
          <button
            type="submit"
            class="btn btn-info btn-block mt-2 blueBtn"
            [disabled]="!appraisarForm.valid || isLoading"
          >
            <ng-container *ngIf="!isLoading"> Continue </ng-container>
            <span *ngIf="isLoading">&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Redirecting...</span>
          </button>
        </div>
      </form>

      <div class="alert alert-success" *ngIf="isAppraisarSuccess && currentRoute === 'appraisar'">
        <strong>{{ isAppraisarSuccess }} </strong>
      </div>

      <!-- <div *ngIf="afterContinueloanOfficerFlag">
          <div class="contineCls">
            <h4>Credit Card Details</h4>
          </div>
          <app-stripe-form [triggeredFrom]="'signUp'" (buttonClicked)="stripeSubmitFun($event)"></app-stripe-form>
        </div> -->
      <div *ngIf="askUserType">
        <h3 class="my-4">I'm a</h3>
        <div class="role-p" style="width: 100%; align-items: center; justify-content: center">
          <div class="role-card" (click)="onUserTyeChange('agent')">
            <img src="assets/images/agent.svg" height="50" />
            <div class="mt-2 user-type">Agent</div>
          </div>
          <div class="role-card ml-4" (click)="onUserTyeChange('loan-officer')">
            <img src="assets/images/Loan-officer.svg" height="50" />
            <div class="mt-2 user-type">Loan Officer</div>
          </div>
          <!-- <div class="role-card ml-4" (click)="onUserTyeChange('appraisar')">
            <img src="assets/images/appraisar.svg" height="50" />
            <div class="mt-2 user-type">Appraiser</div>
          </div> -->
        </div>
      </div>
      <br />
    </div>
  </div>
</div>
<div *ngIf="isChatRedirect" class="" style="min-height: 100%">
  <div class="col-md-12 chatDiv mx-auto">
    <div
      style="position: sticky; top: -30px; left: 0; right: 0; z-index: 1; padding-bottom: 0px; background-color: #fff"
    >
      <button
        *ngIf="isChatRedirect"
        class="close"
        mat-icon-button
        (click)="close()"
        autofocus="false"
        style="top: 0px; right: 0px"
      >
        <mat-icon>close</mat-icon>
      </button>
      <div class="company-logo-container">
        <div>
          <img *ngIf="companyLogo && !hideValuetestLogo" [src]="companyLogo" alt="Company Logo" />
        </div>
        <div *ngIf="!companyLogo && hideValuetestLogo" [ngClass]="{ 'logo-wrapper': hideValuetestLogo }">
          <img src="../../assets/images/compcheck_logo.png" />
        </div>
      </div>
      <h3 class="mt-3 mb-0">
        {{ currentRoute !== 'signup' ? 'Create an account' : askUserType ? '' : 'Login' }}
      </h3>
      <div class="text-center mt-2 redirect-ac" *ngIf="!showResetForm && !afterContinueloanOfficerFlag">
        {{ currentRoute !== 'signup' || askUserType ? 'Already have an account' : "Don't have an account" }}
        ?
        <a class="aCls" (click)="switchFunc(currentRoute !== 'signup' ? 'Login' : 'signup')">{{
          currentRoute !== 'signup' || askUserType ? 'Login' : 'Signup'
        }}</a>
      </div>
    </div>
    <!-- agent form -->
    <form [formGroup]="signupForm" *ngIf="currentRoute === 'agent'" (submit)="agentSignup()">
      <div>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>First Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="firstName"
            id="firstName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="firstName"
            required
            placeholder="First Name*"
          />
          <mat-error
            *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.required"
            class="invalid-feedback"
          >
            First Name is required</mat-error
          >
          <mat-error
            *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="signupControls.firstName.errors && signupControls.firstName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Last Name</mat-label>
          <input
            type="text"
            matInput
            formControlName="lastName"
            id="lastName"
            pattern="^[a-zA-Z]+$"
            aria-describedby="lastName"
            required
            placeholder="Last Name*"
          />
          <mat-error
            *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.required"
            class="invalid-feedback"
          >
            Last Name is required</mat-error
          >
          <mat-error
            *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.maxlength"
            class="invalid-feedback"
          >
            Maximum 25 characters are allowed</mat-error
          >
          <mat-error
            *ngIf="signupControls.lastName.errors && signupControls.lastName.errors.pattern"
            class="invalid-feedback"
          >
            Only alphabets are allowed</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            id="email"
            aria-describedby="email"
            required
            placeholder="Email*"
          />
          <mat-error
            *ngIf="signupControls.email.errors && signupControls.email.errors.required"
            class="invalid-feedback"
            >Email is required</mat-error
          >
          <mat-error *ngIf="signupControls.email.errors && signupControls.email.errors.pattern" class="invalid-feedback"
            >Email must be a valid</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
          <mat-error
            *ngIf="signupControls.phone.errors && signupControls.phone.errors.required"
            class="invalid-feedback"
            aria-label="phone No. is required"
          >
            Phone No. is required
          </mat-error>
          <mat-error
            *ngIf="signupControls.phone.errors && signupControls.phone.errors.pattern"
            class="invalid-feedback"
          >
            Phone number must be valid
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            class="pass-fld"
            aria-describedby="password"
            placeholder="Password*"
            required
          />
          <mat-error
            *ngIf="signupControls.password.errors && signupControls.password.errors.required"
            class="invalid-feedback"
          >
            Password is required
          </mat-error>
          <mat-error
            *ngIf="signupControls.password.errors && signupControls.password.errors.minlength"
            class="invalid-feedback"
          >
            Password must be at least 6 characters</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            type="password"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirm Password*"
            (input)="onConfirmPasswordInput()"
            required
          />
          <mat-error
            *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.required"
            class="invalid-feedback"
          >
            Confirm Password is required
          </mat-error>
          <mat-error
            *ngIf="signupControls.confirmPassword.errors && signupControls.confirmPassword.errors.minlength"
            class="invalid-feedback"
          >
            Confirm Password must be at least 6 characters</mat-error
          >
          <mat-error
            *ngIf="signupControls.confirmPassword.hasError('passwordMismatch') && signupControls.confirmPassword.dirty"
            class="invalid-feedback"
          >
            Passwords do not match.
          </mat-error>
        </mat-form-field>

        <h6 class="addressLabelCls">MLS Access Information <span> * </span></h6>
        <div formGroupName="mlsInfoForm">
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>State</mat-label>
            <mat-select formControlName="state" (selectionChange)="onStateSelection($event)">
              <mat-option value="" disabled> Select State </mat-option>
              <mat-option *ngFor="let state of stateList | keyvalue" [value]="state.key">
                {{ state.value | titlecase }} - {{ state.key | uppercase }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                mlsInfoForm.get('state').errors &&
                mlsInfoForm.get('state').errors.required &&
                mlsInfoForm.get('state').dirty
              "
              class="invalid-feedback"
            >
              State is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" [ngClass]="{ 'select-progress': isLoadingStateMLS }" class="col-md-6">
            <mat-label>MLS Board</mat-label>
            <mat-select [disabled]="isLoadingStateMLS" formControlName="mlsBoard">
              <mat-option value="" disabled>Select MLS Board</mat-option>
              <mat-option *ngFor="let mls of stateMlsList" [value]="mls.MLSBoard">
                {{ mls.MLSBoard }} - {{ mls.MLSName }}
              </mat-option>
              <mat-option value="" *ngIf="!isLoadingStateMLS && !stateMlsList.length">No MLSBoard</mat-option>
            </mat-select>
            <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingStateMLS"></mat-spinner>
          </mat-form-field>

          <div class="form-row" style="margin-left: 0.75rem !important">
            <div class="form-group col-md-9 mb-0" style="display: flex; align-items: center">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Membership Number</mat-label>
                <input
                  matInput
                  type="text"
                  id="membershipNumber"
                  formControlName="memberId"
                  placeholder="Membership Number*"
                />
              </mat-form-field>
            </div>
            <div class="form-group col-md-3" style="display: flex; align-items: center">
              <button
                mat-flat-button
                type="button"
                class="btn btn-primary blueBtn add"
                (click)="addMlsInfo()"
                [disabled]="!mlsInfoForm.valid"
              >
                + ADD
              </button>
            </div>
            <div>
              <span class="info-txt"
                ><mat-icon class="info-icon">info</mat-icon>To help us validate your membership with the MLS, please
                provide your MLS Membership Number.</span
              >
            </div>
          </div>
        </div>
        <div class="row" *ngIf="mlsInformation.data && mlsInformation.data.length > 0">
          <div class="col-md-12">
            <div class="table_base table-container mt-3 mb-5 mls-list">
              <div class="table-responsive table_wrap">
                <mat-spinner *ngIf="isLoadingAgentMLS" class="loading-spinner"></mat-spinner>
                <table
                  mat-table
                  [dataSource]="mlsInformation"
                  class="mat-elevation-z2 w-100"
                  *ngIf="mlsInformation.data && mlsInformation.data.length > 0"
                >
                  <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>State</th>
                    <td mat-cell *matCellDef="let element">
                      {{ stateList[element.state] | titlecase }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="mlsBoard">
                    <th mat-header-cell *matHeaderCellDef>MLS</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.mlsBoard }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="memberId">
                    <th mat-header-cell *matHeaderCellDef>Membership ID</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.memberId }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      [ngClass]="element.status == 'invalid' ? 'incomplete' : 'success'"
                    >
                      {{ element.status == 'invalid' ? 'Pending' : 'Success' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="actionsWrap">Actions</th>
                    <td mat-cell *matCellDef="let element" class="actionsWrap">
                      <button type="button" mat-icon-button aria-label="delete" class="delete">
                        <i class="material-icons" style="font-size: 20px" (click)="deleteMLS(element)"> delete </i>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="mlsTableColumnList"></tr>
                  <tr mat-row *matRowDef="let row; columns: mlsTableColumnList"></tr>
                  <mat-spinner [diameter]="20" strokeWidth="3" *ngIf="isLoadingAgentMLS"></mat-spinner>
                </table>
              </div>
            </div>

            <div
              class="py-2 text-left"
              style="padding-left: 15px"
              *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue == 'valuetest'"
            >
              We’re unable to verify the number you entered as an MLS Member ID. Please ensure you’re not entering your
              license number. <br />
              If verification still doesn’t work, you can proceed with account creation and then call us at
              <b>(702) 591-7245</b> to complete any pending verification. – PropMix
            </div>
            <div
              class="py-2 text-left"
              style="padding-left: 15px"
              *ngIf="showMlsInvalidMessage && appState.appCompanyAliasValue != 'valuetest'"
            >
              Your MLS membership details couldn’t be verified. Please check your Membership ID. If you’re still unable
              to verify, don’t worry — wPlease go ahead and submit the form.
            </div>
          </div>
        </div>
        <div class="flex_center w-100" *ngIf="!isLoadingAgentMLS && !mlsInformation.data">
          <div class="notFound text-center noData">
            <div>
              <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
              <h4>No MLS memberships found</h4>
            </div>
          </div>
        </div>
        <div class="continue">
          <button
            mat-flat-button
            type="submit"
            class="btn btn-primary btn-block blueBtn mt-2"
            *ngIf="signupForm.valid && mlsInformation.data.length != 0 && !isUserAuthenticationProgress"
          >
            <!-- &&
            showCreateAccount -->
            <ng-container *ngIf="!isUserAuthenticationProgress"> Create Account </ng-container>
            <span *ngIf="isUserAuthenticationProgress"
              >&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Creating...</span
            >
          </button>
        </div>
      </div>
    </form>

    <!-- signin form -->
    <form
      [formGroup]="officeForm"
      (ngSubmit)="officeFormSubmit()"
      *ngIf="currentRoute === 'signup' && !showResetForm && !askUserType"
    >
      <div
        class="alert"
        [ngClass]="{ 'alert-danger': alerts.type == 'error', 'text-info pl-0': alerts.type == 'info' }"
        *ngIf="alerts && alerts.type != ''"
      >
        {{ alerts.message }}
      </div>
      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
        <mat-error
          *ngIf="officeFormControls.email.errors && officeFormControls.email.errors.required"
          class="invalid-feedback"
          >Email is required</mat-error
        >
        <mat-error
          *ngIf="officeFormControls.email.errors && officeFormControls.email.errors.pattern"
          class="invalid-feedback"
          >Email must be a valid</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Password</mat-label>
        <input
          matInput
          type="password"
          formControlName="password"
          class="pass-fld"
          aria-describedby="password"
          placeholder="Password*"
          required
        />
        <mat-error
          *ngIf="officeFormControls.password.errors && officeFormControls.password.errors.required"
          class="invalid-feedback"
        >
          Password is required
        </mat-error>
        <mat-error
          *ngIf="officeFormControls.password.errors && officeFormControls.password.errors.minlength"
          class="invalid-feedback"
        >
          Password must be at least 6 characters</mat-error
        >
      </mat-form-field>
      <a class="float-right mb-3 pr-3 forgot-Pass" (click)="goToReset()"> <b> Forgot Password ?</b></a>
      <div class="continue">
        <button class="btn btn-info btn-block blueBtn" [disabled]="!officeForm.valid || isUserAuthenticationProgress">
          <ng-container *ngIf="!isUserAuthenticationProgress"> Login </ng-container>
          <span *ngIf="isUserAuthenticationProgress"
            >&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Logging In...</span
          >
        </button>
      </div>
    </form>

    <!-- RESET FORM -->
    <form *ngIf="showResetForm" [formGroup]="resetForm" (ngSubmit)="resetFormSubmit()">
      <div
        class="alert mb-0"
        [ngClass]="{
          'alert-success': alerts.type == 'success',
          'alert-danger': alerts.type == 'danger',
          'text-info pl-0': alerts.type == 'info'
        }"
        *ngIf="alerts && alerts.type != ''"
      >
        <b>{{ alerts.message }}</b>
      </div>
      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
        <mat-error
          *ngIf="resetFormControls.email.errors && resetFormControls.email.errors.required"
          class="invalid-feedback"
          >Email is required</mat-error
        >
        <mat-error
          *ngIf="resetFormControls.email.errors && resetFormControls.email.errors.pattern"
          class="invalid-feedback"
          >Email must be a valid</mat-error
        >
      </mat-form-field>

      <div class="continue">
        <button class="btn btn-info btn-block blueBtn" [disabled]="!resetForm.valid">Reset Password</button>
      </div>
      <div class="text-center mt-3 redirect-ac">
        Remember your password?
        <a class="aCls" (click)="goToLogin()"> Log in</a>
      </div>
    </form>

    <!-- loan officer form -->
    <form
      [formGroup]="loanOfficer"
      (ngSubmit)="loanOfficeFormSubmit()"
      *ngIf="currentRoute === 'loan-officer' && !afterContinueloanOfficerFlag"
    >
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>First Name</mat-label>
        <input
          type="text"
          matInput
          formControlName="firstName"
          pattern="^[a-zA-Z]+$"
          aria-describedby="firstName"
          required
          placeholder="First Name*"
        />
        <mat-error
          *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.required"
          class="invalid-feedback"
        >
          First Name is required</mat-error
        >
        <mat-error
          *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.maxlength"
          class="invalid-feedback"
        >
          Maximum 25 characters are allowed</mat-error
        >
        <mat-error
          *ngIf="loanOfficerControls.firstName.errors && loanOfficerControls.firstName.errors.pattern"
          class="invalid-feedback"
        >
          Only alphabets are allowed</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Last Name</mat-label>
        <input
          type="text"
          matInput
          formControlName="lastName"
          pattern="^[a-zA-Z]+$"
          aria-describedby="lastName"
          required
          placeholder="Last Name*"
        />
        <mat-error
          *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.required"
          class="invalid-feedback"
        >
          Last Name is required</mat-error
        >
        <mat-error
          *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.maxlength"
          class="invalid-feedback"
        >
          Maximum 25 characters are allowed</mat-error
        >
        <mat-error
          *ngIf="loanOfficerControls.lastName.errors && loanOfficerControls.lastName.errors.pattern"
          class="invalid-feedback"
        >
          Only alphabets are allowed</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
        <mat-error
          *ngIf="loanOfficerControls.email.errors && loanOfficerControls.email.errors.required"
          class="invalid-feedback"
          >Email is required</mat-error
        >
        <mat-error
          *ngIf="loanOfficerControls.email.errors && loanOfficerControls.email.errors.pattern"
          class="invalid-feedback"
          >Email must be a valid</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
        <mat-error
          *ngIf="loanOfficerControls.phone.errors && loanOfficerControls.phone.errors.required"
          class="invalid-feedback"
          aria-label="phone No. is required"
        >
          Phone No. is required
        </mat-error>
        <mat-error
          *ngIf="loanOfficerControls.phone.errors && loanOfficerControls.phone.errors.pattern"
          class="invalid-feedback"
        >
          Phone number must be valid
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Password</mat-label>
        <input
          matInput
          type="password"
          formControlName="password"
          id="password"
          class="pass-fld"
          aria-describedby="password"
          placeholder="Password*"
          required
        />
        <mat-error
          *ngIf="loanOfficerControls.password.errors && loanOfficerControls.password.errors.required"
          class="invalid-feedback"
        >
          Password is required
        </mat-error>
        <mat-error
          *ngIf="loanOfficerControls.password.errors && loanOfficerControls.password.errors.minlength"
          class="invalid-feedback"
        >
          Password must be at least 6 characters</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Confirm Password</mat-label>
        <input
          matInput
          type="password"
          id="confirmPassword"
          formControlName="confirmPassword"
          placeholder="Confirm Password*"
          (input)="onConfirmPasswordInput()"
          required
        />
        <mat-error
          *ngIf="loanOfficerControls.confirmPassword.errors && loanOfficerControls.confirmPassword.errors.required"
          class="invalid-feedback"
        >
          Confirm Password is required
        </mat-error>
        <mat-error
          *ngIf="loanOfficerControls.confirmPassword.errors && loanOfficerControls.confirmPassword.errors.minlength"
          class="invalid-feedback"
        >
          Confirm Password must be at least 6 characters</mat-error
        >
        <mat-error
          *ngIf="
            loanOfficerControls.confirmPassword.hasError('passwordMismatch') &&
            loanOfficerControls.confirmPassword.dirty
          "
          class="invalid-feedback"
        >
          Passwords do not match.
        </mat-error>
      </mat-form-field>

      <h6 class="addressLabelCls">Address (optional)</h6>
      <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>Address</mat-label>
        <input matInput type="text" id="address" formControlName="streetAddress" placeholder="Street Address" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>City</mat-label>
        <input matInput type="text" id="city" formControlName="city" placeholder="City" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" (selectionChange)="onStateSelection($event)">
          <mat-option value="" disabled> Select State </mat-option>
          <mat-option *ngFor="let state of stateList | keyvalue" [value]="state.key">
            {{ state.value | titlecase }} - {{ state.key | uppercase }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Zipcode</mat-label>
        <input matInput type="number" id="zip" formControlName="zipCode" placeholder="ZIP" />
      </mat-form-field>
      <div class="continue">
        <button type="submit" class="btn btn-info btn-block mt-2 blueBtn" [disabled]="!loanOfficer.valid || isLoading">
          <ng-container *ngIf="!isLoading"> Sign Up </ng-container>
          <span *ngIf="isLoading">&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Redirecting...</span>
        </button>
        <div class="loanOfficer-verbage" *ngIf="displayLoanOfficerVerbage">
          <span> ValueTest allows you to partner with a local real estate agent and use MLS data and insights. </span>
          <span> For a public-records-only capability please use the free CompCheck.ai service. </span>
        </div>
      </div>
    </form>

    <!-- appraisar Signup Form  -->
    <form
      [formGroup]="appraisarForm"
      (ngSubmit)="appraisarFormSubmit()"
      *ngIf="currentRoute === 'appraisar' && !isAppraisarSuccess"
    >
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>First Name</mat-label>
        <input
          type="text"
          matInput
          formControlName="firstName"
          pattern="^[a-zA-Z]+$"
          aria-describedby="firstName"
          required
          placeholder="First Name*"
        />
        <mat-error
          *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.required"
          class="invalid-feedback"
        >
          First Name is required</mat-error
        >
        <mat-error
          *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.maxlength"
          class="invalid-feedback"
        >
          Maximum 25 characters are allowed</mat-error
        >
        <mat-error
          *ngIf="appraisarControls.firstName.errors && appraisarControls.firstName.errors.pattern"
          class="invalid-feedback"
        >
          Only alphabets are allowed</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Last Name</mat-label>
        <input
          type="text"
          matInput
          formControlName="lastName"
          pattern="^[a-zA-Z]+$"
          aria-describedby="lastName"
          required
          placeholder="Last Name*"
        />
        <mat-error
          *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.required"
          class="invalid-feedback"
        >
          Last Name is required</mat-error
        >
        <mat-error
          *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.maxlength"
          class="invalid-feedback"
        >
          Maximum 25 characters are allowed</mat-error
        >
        <mat-error
          *ngIf="appraisarControls.lastName.errors && appraisarControls.lastName.errors.pattern"
          class="invalid-feedback"
        >
          Only alphabets are allowed</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" aria-describedby="email" required placeholder="Email*" />
        <mat-error
          *ngIf="appraisarControls.email.errors && appraisarControls.email.errors.required"
          class="invalid-feedback"
          >Email is required</mat-error
        >
        <mat-error
          *ngIf="appraisarControls.email.errors && appraisarControls.email.errors.pattern"
          class="invalid-feedback"
          >Email must be a valid</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone" id="phone" aria-describedby="phone" required placeholder="Phone*" />
        <mat-error
          *ngIf="appraisarControls.phone.errors && appraisarControls.phone.errors.required"
          class="invalid-feedback"
          aria-label="phone No. is required"
        >
          Phone No. is required
        </mat-error>
        <mat-error
          *ngIf="appraisarControls.phone.errors && appraisarControls.phone.errors.pattern"
          class="invalid-feedback"
        >
          Phone number must be valid
        </mat-error>
      </mat-form-field>

      <div class="continue">
        <button
          type="submit"
          class="btn btn-info btn-block mt-2 blueBtn"
          [disabled]="!appraisarForm.valid || isLoading"
        >
          <ng-container *ngIf="!isLoading"> Continue </ng-container>
          <span *ngIf="isLoading">&nbsp;&nbsp;<i class="fa fa-spinner fa-spin"></i> Redirecting...</span>
        </button>
      </div>
    </form>

    <div class="alert alert-success" *ngIf="isAppraisarSuccess && currentRoute === 'appraisar'">
      <strong>{{ isAppraisarSuccess }} </strong>
    </div>

    <!-- <div *ngIf="afterContinueloanOfficerFlag">
          <div class="contineCls">
            <h4>Credit Card Details</h4>
          </div>
          <app-stripe-form [triggeredFrom]="'signUp'" (buttonClicked)="stripeSubmitFun($event)"></app-stripe-form>
        </div> -->
    <div *ngIf="askUserType">
      <h3 class="my-4">I'm a</h3>
      <div class="role-p" style="width: 100%; align-items: center; justify-content: center">
        <div class="role-card" (click)="onUserTyeChange('agent')">
          <img src="assets/images/agent.svg" height="50" />
          <div class="mt-2 user-type">Agent</div>
        </div>
        <div class="role-card ml-4" (click)="onUserTyeChange('loan-officer')">
          <img src="assets/images/Loan-officer.svg" height="50" />
          <div class="mt-2 user-type">Loan Officer</div>
        </div>
        <!-- <div class="role-card ml-4" (click)="onUserTyeChange('appraisar')">
            <img src="assets/images/appraisar.svg" height="50" />
            <div class="mt-2 user-type">Appraiser</div>
          </div> -->
      </div>
    </div>
    <br />
  </div>
</div>
